import { getVehicles, getVehicle, createVehicle, updateVehicle, deleteVehicle } from "@/api/vehicles";
import { createStore } from "vuex";
import { VehicleState } from "../state";
import { Vehicle } from "../types";

export const vehicleStore = createStore({
  state: {
    vehicles: [],
    vehicle: {} as any,
    vehicleListTotal: 0,
    vehicleListLoading: false
  },
  getters: {
    vehicles: (state: VehicleState) => state.vehicles,
    vehicle: (state: VehicleState) => state.vehicle,
    vehicleListTotal: (state: VehicleState) => state.vehicleListTotal,
    vehicleListLoading: (state: VehicleState) => state.vehicleListLoading
  },
  mutations: {
    setVehicles(state: VehicleState, payload: Vehicle[]) {
      state.vehicles = payload
    },
    setVehicle(state: VehicleState, payload: Vehicle) {
      state.vehicle = payload
    },
    clearVehicle(state: VehicleState) {
      state.vehicle = {} as any
    },
    deleteVehicleById(state: VehicleState, payload: any) {
      state.vehicles = state.vehicles.filter((vehicle: any) => {
        return String(vehicle.id) !== String(payload.id)
      })
      state.vehicleListTotal = state.vehicleListTotal - 1
    },
    setVehicleListTotal(state: VehicleState, payload: number) {
      state.vehicleListTotal = payload
    },
    setVehicleListLoading(state: VehicleState, payload: boolean) {
      state.vehicleListLoading = payload
    }
  },
  actions: {
    async fetchVehicles({ commit }, pagination) {
      commit('setVehicleListLoading', true)
      const response = await getVehicles(pagination)
      commit('setVehicles', response.data.data)
      commit('setVehicleListTotal', response.data.total)
      commit('setVehicleListLoading', false)
    },
    async fetchVehicle({ commit }, id) {
      if(this.state.vehicleListLoading) return

      commit('setVehicleListLoading', true)
      const response = await getVehicle(id)
      commit('setVehicle', response.data.data)
    },
    async createVehicle({ commit }, data) {
      const response = await createVehicle(data)
      commit('setVehicle', response.data.data)
      return response.data.data.id
    },
    async updateVehicle({ commit }, { id, data }) {
      const response = await updateVehicle(id, data)
      commit('setVehicle', response.data.data)
    },
    async deleteVehicle({ commit }, id) {
      await deleteVehicle(id)
      commit('deleteVehicleById', { id: id })
    }
  },
})

export default vehicleStore;
